module.exports = __webpack_public_path__ + "img/no_image.48fb7668.png";